import React, {memo} from 'react';

import moment from 'moment-tz';

import {
  getApprovedText,
  getCreatedText,
  getModifiedText,
  SortedType,
} from 'app/general/dashboards/ItemLastActivity';

type Props = {
  document: SortedType;
};

export const ModifiedCreatedDataStamp = memo<Props>(({document}: Props) => {
  const modificationOlderEnough =
    moment(document.edited_at).diff(moment(document.created_at), 'minutes') > 1;
  const someoneElseChanged =
    document.author &&
    document.original_author &&
    document.author.id !== document.original_author.id;
  // show the 'Edited by' if author did more changes after 1 minute of
  // creation time or someone else changed the procedure
  const showModified = modificationOlderEnough || someoneElseChanged;
  return (
    <small className="text-muted">
      <span className="mb-1 d-block d-sm-inline">
        {getCreatedText(document)}
      </span>
      {showModified != null ? (
        <span className="mb-1">
          <span className="d-none d-sm-inline"> • </span>
          <span className="d-block d-sm-inline">
            {getModifiedText(document)}
          </span>
        </span>
      ) : null}
      {document.approved_at != null ? (
        <span className="mb-1">
          <span className="d-none d-sm-inline"> • </span>
          <span className="d-block d-sm-inline">
            {getApprovedText(document)}
          </span>
        </span>
      ) : null}
    </small>
  );
});
